<template>
  <router-link class="ui card" :to="url">
    <sui-card-content class="compact">
      <sui-button-group class="right floated" size="mini">
        <sui-button :icon="localAccessIcon" data-goal="PROJECT_CARD_ACCESS" v-if="account.limits.invite && access.tariffManagement" @click.stop.prevent="$modals.entityAccess.open(project)" />
      </sui-button-group>
      <sui-card-header>
        {{project.name}}
      </sui-card-header>
      <sui-card-meta :title="project.created">
        created {{momentFromNow(project.created)}}
      </sui-card-meta>
    </sui-card-content>
    <sui-card-content class="children services" :style="{background}">
      <div class="empty" v-if="!services.length">No services</div>
      <div class="children-item" :class="service.status" v-for="service in services" :key="service.id" @click.stop.prevent="service.openPage()">
        <Logo :entity="service" inline />{{service.name}}
      </div>
    </sui-card-content>
    <sui-card-content class="children hosts">
      <div class="empty" v-if="!hosts.length">No hosts</div>
      <div class="children-item" :class="host.status" v-for="host in hosts" :key="host.id" @click.stop.prevent="host.openPage()">
        <Logo :entity="host" inline />{{host.name}}
      </div>
    </sui-card-content>
  </router-link>
</template>

<script>
  import {mapGetters} from 'vuex'
  import orderBy from 'lodash/orderBy'

  export default {
    name: 'ProjectCard',
    props: {
      project: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['access', 'account', 'config', 'member']),
      url() {
        return this.project._path
      },
      background() {
        return this.config.colorCards ? `linear-gradient(135deg, transparent, ${this.project.constructor.color}22)` : 'transparent'
      },
      services() {
        return orderBy(this.project._services, ['type', 'created'], ['desc', 'desc'])
      },
      hosts() {
        return orderBy(this.project._hosts, ['providerType', 'created'], ['desc', 'desc'])
      },
      localAccessIcon() {
        return 'users' + (this.project.rules.local && Object.keys(this.project.rules.local).length ? ' blue' : '')
      },
    },
  }
</script>

<style scoped>
  .empty { line-height: 1.3em; color: #ccc; }
  .children { display: flex; flex-wrap: wrap; align-content: flex-start; }
  .services { flex-grow: 1!important; flex: 1; }
  .children-item { margin: .1em 1em .1em 0; display: flex; align-items: center; }
  .children-item.OFFLINE { opacity: .3 }
  .children-item.NOT_DEPLOYED { opacity: .3 }
  .children-item:hover { color: #328fd4!important; }
  .right.floated.buttons { position: absolute; top: 0; right: 0; }
  .right.floated.buttons .button { margin-left: -1em; padding-right: 1.8em; border-radius: 0; border-bottom-left-radius: 1em; border-bottom: 1px solid #eee; border-left: 1px solid #eee; background-color: #f3f3f3; box-shadow: none!important; }
  .right.floated.buttons .button:hover { background-color: #eee; }
  .right.floated.buttons .button:last-child { padding-right: 0.785714em; }
  .content:first-child > .right.floated.buttons .button:last-child { border-top-right-radius: 0.28571429rem; }
  .right.floated.buttons .button >>> .icon { margin-top: -1px!important; }
</style>
